import { api } from "../api";

export const FornecedorService = {
  postFornecedor: async (data) => {
    const response = await api.post('/fornecedor', data);
    return response.data;
  },
  postCadastroFinal: async (token, data) => {
    let response = await FornecedorService.filtrarFornecedores(token, {}, false);

    response = await api.post(`/fornecedor/${response[0].codcli}/cadfin/questionario`, data, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  postAvaliacaoCadastro: async (token, codCli, data) => {
    const response = await api.post(`/fornecedor/${codCli}/avaliacao`, data, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  postAvaliacaoEmLote: async (token, data) => {
    const response = await api.post(`/fornecedor/avaliacao`, data, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  updateCadastro: async (token, codCli, data) => {
    const response = await api.patch(`/fornecedor/${codCli}`, data, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  updateFornecedorByCodCli: async (token, codCli, data) => {
    const response = await api.patch(`/fornecedor/${codCli}`, data, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  getFornecedores: async (token, paged = true, page = 1, limit = 5) => {
    const url = paged ? `/fornecedor?page=${page}&limit=${limit}` : '/fornecedor';
    const headers = { "Authorization": token };
    if (paged) headers["X-Paginate"] = true;

    const response = await api.get(url, { headers });
    return response.data;
  },
  getFornecedorByCodCli: async (token, codCli) => {
    const response = await api.get(`/fornecedor/${codCli}`, {
      headers: { "Authorization": token, "X-Paginate": true }
    });

    return response.data;
  },
  getFornecedoresSemAvaliacao: async (token, paged = true, page = 1, limit = 5) => {
    let url = paged ? `/fornecedor/avaliacao/pendente?page=${page}&limit=${limit}` : '/fornecedor/avaliacao/pendente';
    const headers = { "Authorization": token };

    if (paged) headers["X-Paginate"] = true;

    const response = await api.get(url, { headers });
    return response.data;
  },
  getFornecedoresProximosAoVencimento: async (token, paged = true, page = 1, limit = 5) => {
    let url = paged ? `/fornecedor/avaliacao/vencimento?page=${page}&limit=${limit}` : '/fornecedor/avaliacao/vencimento';
    const headers = { "Authorization": token };

    if (paged) headers["X-Paginate"] = true;

    const response = await api.get(url, { headers });
    return response.data;
  },
  getFornecedoresSemQuestionario: async (token, paged = true, page = 1, limit = 5) => {
    let url = paged ? `/fornecedor/questionario/pendente?page=${page}&limit=${limit}` : '/fornecedor/questionario/pendente';

    const headers = { "Authorization": token };

    if (paged) headers["X-Paginate"] = true;

    const response = await api.get(url, { headers });
    return response.data;
  },
  getAvaliacoes: async (token, paged = true, page = 1, limit = 5) => {
    let url = paged ? `/fornecedor/avaliacao?page=${page}&limit=${limit}` : '/fornecedor/avaliacao';
    const headers = { "Authorization": token };

    if (paged) headers["X-Paginate"] = true;

    const response = await api.get(url, { headers });
    return response.data;
  },
  getAvaliacoesByCodCli: async (token, codCli) => {
    const response = await api.get(`/fornecedor/${codCli}/avaliacao`, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  filtrarFornecedores: async (token, data, paged = true, page = 1, limit = 5) => {
    const url = paged ? `/fornecedor/filtrar?page=${page}&limit=${limit}` : '/fornecedor/filtrar';
    const headers = { "Authorization": token };
    if (paged) headers["X-Paginate"] = true;

    const response = await api.post(url, data, { headers });
    return response.data;
  },
  checarCadastro: async (token, codcli, tipcad) => {
    const response = await api.get(`/fornecedor/${codcli}/checar?tipcad=${tipcad}`, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  aprovarCadInicialFornecedor: async (token, codope, arq486, endele, codcli, obspar = null) => {
    const response = await api.patch(`/fornecedor/${codcli}/cadini/${arq486}/aprovar`, { codope, obspar }, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  reprovarCadInicialFornecedor: async (token, codope, arq486, endele, codcli, obspar = null) => {
    const response = await api.patch(`/fornecedor/${codcli}/cadini/${arq486}/reprovar`, { codope, obspar }, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  aprovarCadFinalFornecedor: async (token, codope, arq486, endele, codcli, obspar = null) => {
    const response = await api.patch(`/fornecedor/${codcli}/cadfin/${arq486}/aprovar`, { codope, obspar }, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  reprovarCadFinalFornecedor: async (token, codope, arq486, endele, codcli, obspar = null) => {
    const response = await api.patch(`/fornecedor/${codcli}/cadfin/${arq486}/reprovar`, { codope, obspar }, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  gerarSenhaTemporaria: async(token, codcli) => {
    const response = await api.patch(`/fornecedor/${codcli}/senha`, {}, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  ativarFornecedor: async (token, codcli) => {
    const response = await api.patch(`/fornecedor/${codcli}/ativar`, {}, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  inativarFornecedor: async (token, codcli) => {
    const response = await api.patch(`/fornecedor/${codcli}/inativar`, {}, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  consultaSintegra: async (token, codcli) => {
    const response = await api.get(`/fornecedor/${codcli}/sintegra`, {
      headers: { "Authorization": token }
    });

    return response.data;
  },
  getOrdensCompra: async(token, codcli, dataInicio, dataFim, paged = true, page = 1, limit = 5) => {
    const url = paged ? `/fornecedor/${codcli}/ordens?dataInicio=${dataInicio}&dataFim=${dataFim}&page=${page}&limit=${limit}` 
        : `/fornecedor/${codcli}/ordens?dataInicio=${dataInicio}&dataFim=${dataFim}`;
    const headers = { "Authorization": token };
    if (paged) headers["X-Paginate"] = true;

    const response = await api.get(url, { headers });
    return response.data;
  },
  filtrarOrdensCompra: async(token, codcli, data, dataInicio, dataFim, paged = true, page = 1, limit = 5) => {
    const url = paged ? `/fornecedor/${codcli}/ordens/filtrar?dataInicio=${dataInicio}&dataFim=${dataFim}&page=${page}&limit=${limit}`
        : `/fornecedor/${codcli}/ordens/filtrar?dataInicio=${dataInicio}&dataFim=${dataFim}`;
    const headers = { "Authorization": token };
    if (paged) headers["X-Paginate"] = true;

    const response = await api.post(url, data, { headers });
    return response.data;
  }
};
